import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, skip } from 'rxjs/operators';
import { DashboardPluginsState } from 'src/app/core/state/dashboard-plugins.state';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';

/**
 * Service to provide filtered department change events for dashboard components.
 * Handles common filtering logic to prevent unwanted updates.
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardDepartmentChangeService {
  constructor(private store: Store) {}

  /**
   * Returns an observable that emits when the department changes,
   * but filters out changes when:
   * - A dashboard modal is open (user might be navigating away)
   * - Initial emission (to avoid duplicate loads on component init)
   */
  getDepartmentChanges(): Observable<string> {
    return this.store.select(TenantUserAccessState.currentDepartmentId).pipe(
      filter((departmentId) => !!departmentId),
      distinctUntilChanged(),
      skip(1), // Skip the initial emission to avoid duplicate loads on component init
      filter(() => {
        // Skip update if any dashboard modal is open (user might be navigating away)
        const isModalOpen = this.store.selectSnapshot(DashboardPluginsState.isDashboardModalOpen);
        return !isModalOpen;
      })
    );
  }
}
